import { render, staticRenderFns } from "./companyAuthentication.vue?vue&type=template&id=2147c8d4&scoped=true"
import script from "./companyAuthentication.vue?vue&type=script&lang=js"
export * from "./companyAuthentication.vue?vue&type=script&lang=js"
import style0 from "./companyAuthentication.vue?vue&type=style&index=0&id=2147c8d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147c8d4",
  null
  
)

export default component.exports